const SESSION_KEY = "cooldoc_session_id";
const CONSENT_KEY = "cooldoc_insight_consent";
const PROFILE_KEY = "cooldoc_research_profile";

export const getSessionId = () => {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = window.crypto?.randomUUID?.() || `cd-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

const request = async (method, body) => {
  const response = await fetch("/api/insights", {
    method,
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error(`insights-${response.status}`);
  return response.json();
};

export const saveCheckpointInsight = async (profile) => {
  const safeProfile = {
    ageRange: profile.ageRange || "not_provided",
    region: profile.region || "not_provided",
    purpose: profile.purpose || "not_provided",
    source: profile.source || "not_provided",
  };
  localStorage.setItem(PROFILE_KEY, JSON.stringify(safeProfile));
  localStorage.setItem(CONSENT_KEY, profile.insightConsent ? "yes" : "no");
  if (!profile.insightConsent) return { saved: false, reason: "no-consent" };
  try {
    const result = await request("POST", { action: "checkpoint", sessionId: getSessionId(), consent: true, language: localStorage.getItem("cooldoc_lang") === "ko" ? "ko" : "en", profile: safeProfile });
    localStorage.removeItem("cooldoc_insight_pending");
    return { saved: result.ok };
  } catch (error) {
    localStorage.setItem("cooldoc_insight_pending", "checkpoint");
    return { saved: false, reason: "network" };
  }
};

export const saveResultInsight = async (type, scores) => {
  if (localStorage.getItem(CONSENT_KEY) !== "yes") return { saved: false, reason: "no-consent" };
  try {
    const result = await request("POST", { action: "result", sessionId: getSessionId(), consent: true, resultType: type.toUpperCase(), scores });
    localStorage.removeItem("cooldoc_insight_pending");
    return { saved: result.ok };
  } catch (error) {
    localStorage.setItem("cooldoc_insight_pending", "result");
    return { saved: false, reason: "network" };
  }
};

export const deleteMyInsightData = async () => {
  const id = localStorage.getItem(SESSION_KEY);
  if (id && localStorage.getItem(CONSENT_KEY) === "yes") {
    try { await request("DELETE", { sessionId: id }); }
    catch (error) { return { deleted: false, reason: "network" }; }
  }
  [SESSION_KEY, CONSENT_KEY, PROFILE_KEY, "cooldoc_insight_pending", "cooldoc_name", "cooldoc_scores"].forEach((key) => localStorage.removeItem(key));
  return { deleted: true };
};

export const getLocalResearchProfile = () => {
  try { return JSON.parse(localStorage.getItem(PROFILE_KEY)) || {}; }
  catch (_) { return {}; }
};
